import RoleManage from './role_manage.vue';

export default RoleManage;
